import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/index.css";
import App from "@/App";
import NomeCpfPage from "@/pages/NomeCpfPage";
import SenhaPage from "@/pages/SenhaPage";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/nome-cpf" element={<NomeCpfPage />} />
        <Route path="/senha" element={<SenhaPage />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
);
